(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wwfs-project-builder-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wwfs-project-builder-v5')) {
    class WWFSProjectFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialised === 'true') return;

        this.graphElement = this.querySelector('[data-wwfs-pf-graph]');
        this.fallback = this.querySelector('[data-wwfs-pf-fallback]');
        this.form = this.querySelector('[data-wwfs-pf-form]');
        this.projectSelect = this.querySelector('[data-wwfs-pf-project]');
        this.journey = this.querySelector('[data-wwfs-pf-journey]');
        this.journeyItems = this.querySelector('[data-wwfs-pf-journey-items]');
        this.questionHost = this.querySelector('[data-wwfs-pf-question]');
        this.actions = this.querySelector('[data-wwfs-pf-actions]');
        this.backButton = this.querySelector('[data-wwfs-pf-back]');
        this.primaryButton = this.querySelector('[data-wwfs-pf-primary]');
        this.resetButton = this.querySelector('[data-wwfs-pf-reset]');
        this.resultOutput = this.querySelector('[data-wwfs-pf-result]');
        this.status = this.querySelector('[data-wwfs-pf-status]');

        if (!this.graphElement || !this.form || !this.projectSelect || !this.questionHost || !this.resultOutput) return;

        try {
          this.graph = JSON.parse(this.graphElement.textContent);
          this.validateGraph(this.graph);
        } catch (error) {
          this.dataset.failed = 'true';
          return;
        }

        this.state = this.createInitialState();
        this.populateProjectSelect();
        this.bindEvents();
        this.fallback.hidden = true;
        this.form.hidden = false;
        this.dataset.initialised = 'true';
      }

      createInitialState() {
        return {
          project: null,
          history: [],
          currentNodeId: null,
          currentSelection: '',
          outcomeId: null,
          resultShown: false
        };
      }

      bindEvents() {
        this.onChange = this.handleChange.bind(this);
        this.onSubmit = this.handleSubmit.bind(this);
        this.onBack = this.handleBack.bind(this);
        this.onReset = this.handleReset.bind(this);

        this.form.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit);
        this.backButton.addEventListener('click', this.onBack);
        this.resetButton.addEventListener('click', this.onReset);
      }

      populateProjectSelect() {
        const placeholder = this.projectSelect.options[0];
        this.projectSelect.replaceChildren(placeholder);

        this.graph.start.options.forEach((option) => {
          const element = document.createElement('option');
          element.value = option.value;
          element.textContent = option.label;
          this.projectSelect.append(element);
        });
      }

      handleChange(event) {
        if (event.target === this.projectSelect) {
          this.startProject(event.target.value);
          return;
        }

        if (event.target.matches('[data-wwfs-pf-choice]')) {
          this.state.currentSelection = event.target.value;
          this.primaryButton.disabled = false;
        }
      }

      startProject(value) {
        this.state = this.createInitialState();
        this.clearResultPreview();
        this.questionHost.replaceChildren();

        const option = this.graph.start.options.find((item) => item.value === value);
        if (!option) {
          this.actions.hidden = true;
          this.journey.hidden = true;
          return;
        }

        this.state.project = { value: option.value, label: option.label };
        this.actions.hidden = false;
        this.renderJourney();

        if (option.next) {
          this.renderQuestion(option.next);
        } else {
          this.state.outcomeId = option.result;
          this.renderReady();
        }
      }

      renderQuestion(nodeId, selectedValue = '', shouldFocus = false) {
        const node = this.graph.nodes[nodeId];
        this.state.currentNodeId = nodeId;
        this.state.currentSelection = selectedValue;
        this.state.outcomeId = null;
        this.state.resultShown = false;
        this.questionHost.replaceChildren();

        const fieldset = document.createElement('fieldset');
        fieldset.className = 'wwfs-pf__fieldset';

        const legend = document.createElement('legend');
        legend.className = 'wwfs-pf__legend';

        const step = document.createElement('span');
        step.className = 'wwfs-pf__step-number';
        step.textContent = `Step ${this.state.history.length + 2}`;

        legend.append(step, document.createTextNode(node.question));
        fieldset.append(legend);

        if (node.help) {
          const help = document.createElement('p');
          help.className = 'wwfs-pf__question-help';
          help.id = `${this.id}-${nodeId}-help`;
          help.textContent = node.help;
          fieldset.setAttribute('aria-describedby', help.id);
          fieldset.append(help);
        }

        const grid = document.createElement('div');
        grid.className = 'wwfs-pf__choice-grid';

        node.options.forEach((option, index) => {
          const label = document.createElement('label');
          label.className = 'wwfs-pf__choice';

          const input = document.createElement('input');
          input.className = 'wwfs-pf__choice-input';
          input.type = 'radio';
          input.name = `${this.id}-${nodeId}`;
          input.value = option.value;
          input.id = `${this.id}-${nodeId}-${index}`;
          input.checked = option.value === selectedValue;
          input.setAttribute('data-wwfs-pf-choice', '');

          const card = document.createElement('span');
          card.className = 'wwfs-pf__choice-card';
          card.textContent = option.label;

          label.append(input, card);
          grid.append(label);
        });

        fieldset.append(grid);
        this.questionHost.append(fieldset);
        this.primaryButton.hidden = false;
        this.primaryButton.disabled = !selectedValue;
        this.primaryButton.textContent = 'Continue';
        this.backButton.hidden = this.state.history.length === 0;
        this.renderJourney();
        this.announce(`Next question: ${node.question}`);

        if (shouldFocus) {
          const focusTarget = grid.querySelector(':checked') || grid.querySelector('[data-wwfs-pf-choice]');
          window.requestAnimationFrame(() => focusTarget?.focus());
        }
      }

      handleSubmit(event) {
        event.preventDefault();

        if (this.state.currentNodeId) {
          this.advanceQuestion();
          return;
        }

        if (this.state.outcomeId) this.showResult();
      }

      advanceQuestion() {
        const node = this.graph.nodes[this.state.currentNodeId];
        const option = node.options.find((item) => item.value === this.state.currentSelection);
        if (!option) return;

        this.state.history.push({
          nodeId: this.state.currentNodeId,
          optionValue: option.value,
          label: option.label
        });

        if (option.next) {
          this.renderQuestion(option.next, '', true);
        } else {
          this.state.currentNodeId = null;
          this.state.currentSelection = '';
          this.state.outcomeId = option.result;
          this.renderReady();
        }
      }

      renderReady() {
        this.questionHost.replaceChildren();

        const ready = document.createElement('div');
        ready.className = 'wwfs-pf__ready';

        const title = document.createElement('strong');
        title.textContent = 'Your project route is ready';

        const copy = document.createElement('p');
        copy.textContent = 'Show the recommended checks, product ranges and tools in the order you’ll need them.';

        ready.append(title, copy);
        this.questionHost.append(ready);
        this.primaryButton.hidden = false;
        this.primaryButton.disabled = false;
        this.primaryButton.textContent = 'Show me what I need';
        this.backButton.hidden = false;
        this.renderJourney();
        this.showReadyPreview();
        this.announce('Project route ready. Select Show me what I need.');
      }

      handleBack() {
        const previous = this.state.history.pop();
        if (!previous) return;

        this.state.outcomeId = null;
        this.state.resultShown = false;
        this.clearResultPreview();
        this.renderQuestion(previous.nodeId, previous.optionValue, true);
      }

      handleReset() {
        this.state = this.createInitialState();
        this.projectSelect.value = '';
        this.questionHost.replaceChildren();
        this.journey.hidden = true;
        this.journeyItems.replaceChildren();
        this.actions.hidden = true;
        this.clearResultPreview();
        this.announce('Project finder reset.');
        this.projectSelect.focus();
      }

      renderJourney() {
        if (!this.state.project) {
          this.journey.hidden = true;
          return;
        }

        const labels = [this.state.project.label, ...this.state.history.map((entry) => entry.label)];
        const fragment = document.createDocumentFragment();

        labels.forEach((labelText) => {
          const item = document.createElement('span');
          item.className = 'wwfs-pf__journey-item';
          item.textContent = labelText;
          fragment.append(item);
        });

        this.journeyItems.replaceChildren(fragment);
        this.journey.hidden = false;
      }

      showReadyPreview() {
        const wrapper = document.createElement('div');
        wrapper.className = 'wwfs-pf__result-empty';

        const number = document.createElement('span');
        number.className = 'wwfs-pf__result-empty-number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = '✓';

        const kicker = document.createElement('p');
        kicker.className = 'wwfs-pf__result-kicker';
        kicker.textContent = 'Ready';

        const title = document.createElement('h3');
        title.textContent = 'We’ve narrowed the project down';

        const copy = document.createElement('p');
        copy.textContent = 'Select “Show me what I need” to display your ordered route.';

        wrapper.append(number, kicker, title, copy);
        this.resultOutput.replaceChildren(wrapper);
      }

      clearResultPreview() {
        delete this.dataset.hasResult;
        const wrapper = document.createElement('div');
        wrapper.className = 'wwfs-pf__result-empty';

        const number = document.createElement('span');
        number.className = 'wwfs-pf__result-empty-number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = '01';

        const kicker = document.createElement('p');
        kicker.className = 'wwfs-pf__result-kicker';
        kicker.textContent = 'Your tailored route';

        const title = document.createElement('h3');
        title.textContent = 'Tell us about the job';

        const copy = document.createElement('p');
        copy.textContent = 'We’ll narrow the project down, then show the most useful guidance, product ranges and tools in a sensible order.';

        wrapper.append(number, kicker, title, copy);
        this.resultOutput.replaceChildren(wrapper);
      }

      showResult() {
        const outcome = this.graph.results[this.state.outcomeId];
        if (!outcome) return;

        this.bundleControls = [];

        const wrapper = document.createElement('div');
        wrapper.className = 'wwfs-pf__result-main';

        const kicker = document.createElement('p');
        kicker.className = 'wwfs-pf__result-kicker';
        kicker.textContent = 'Your project route';

        const heading = document.createElement('h3');
        heading.className = 'wwfs-pf__result-heading';
        heading.tabIndex = -1;
        heading.textContent = outcome.title;

        const summary = document.createElement('p');
        summary.className = 'wwfs-pf__result-summary';
        summary.textContent = outcome.summary;

        wrapper.append(kicker, heading, summary);

        if (outcome.notice) wrapper.append(this.createNotice(outcome.notice));

        const list = document.createElement('ol');
        list.className = 'wwfs-pf__result-list';

        outcome.links.forEach((linkData) => {
          const destination = this.graph.destinations[linkData.destination];
          const safeUrl = destination ? this.safeUrl(destination.url) : null;
          if (!safeUrl) return;

          const item = document.createElement('li');
          item.className = 'wwfs-pf__result-card';

          const stage = document.createElement('span');
          stage.className = 'wwfs-pf__result-stage';
          stage.textContent = linkData.stage;

          const link = document.createElement('a');
          link.className = 'wwfs-pf__result-link';
          link.href = safeUrl;
          link.textContent = `${destination.label} →`;

          const text = document.createElement('p');
          text.className = 'wwfs-pf__result-text';
          text.textContent = linkData.text;

          if (destination.type === 'product') {
            item.classList.add('wwfs-pf__result-card--product');

            const content = document.createElement('div');
            content.className = 'wwfs-pf__product-content';
            content.append(stage, link, text);
            item.append(content);

            const control = this.createProductControl(item, content, destination, safeUrl, link);
            this.bundleControls.push(control);
            this.hydrateProductControl(control);
          } else {
            item.append(stage, link, text);
          }

          list.append(item);
        });

        wrapper.append(list);

        if (this.bundleControls.length) wrapper.append(this.createBundlePanel());

        const footnote = document.createElement('p');
        footnote.className = 'wwfs-pf__result-footnote';
        footnote.textContent = 'This finder is a product-selection starting point. Always follow the flooring, product and system manufacturers’ current technical instructions and test where advised.';

        wrapper.append(footnote);
        this.resultOutput.replaceChildren(wrapper);
        this.dataset.hasResult = 'true';
        this.state.resultShown = true;
        this.primaryButton.hidden = true;
        this.backButton.hidden = false;
        this.announce('Recommendations ready. Tick the products you need and add them together, or open any product for full details.');
        heading.focus();
      }

      createProductControl(item, content, destination, safeUrl, productLink) {
        const media = document.createElement('a');
        media.className = 'wwfs-pf__product-media';
        media.href = safeUrl;

        const mediaLoading = document.createElement('span');
        mediaLoading.className = 'wwfs-pf__product-media-loading';
        mediaLoading.textContent = 'Loading product…';
        media.append(mediaLoading);
        item.prepend(media);

        const vendor = document.createElement('p');
        vendor.className = 'wwfs-pf__product-vendor';
        vendor.textContent = 'WWFS';
        content.insertBefore(vendor, productLink);

        const price = document.createElement('p');
        price.className = 'wwfs-pf__product-price';
        price.textContent = 'Checking price…';

        const tax = document.createElement('p');
        tax.className = 'wwfs-pf__product-tax';
        tax.textContent = 'Inc. VAT where applicable';
        content.append(price, tax);

        const picker = document.createElement('div');
        picker.className = 'wwfs-pf__product-picker';

        const variantLabel = document.createElement('span');
        variantLabel.className = 'wwfs-pf__variant-label';
        variantLabel.textContent = 'Choose option';

        const variantButtons = document.createElement('div');
        variantButtons.className = 'wwfs-pf__variant-buttons';
        variantButtons.hidden = true;

        const checkLabel = document.createElement('label');
        checkLabel.className = 'wwfs-pf__product-check';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.disabled = true;
        checkbox.setAttribute('aria-label', `Add ${destination.label.replace(/^View (the )?/i, '')} to this bundle`);

        const checkText = document.createElement('span');
        checkText.textContent = 'Include in project basket';
        checkLabel.append(checkbox, checkText);

        const select = document.createElement('select');
        select.className = 'wwfs-pf__variant-select';
        select.disabled = true;
        select.setAttribute('aria-label', `Choose an option for ${destination.label.replace(/^View (the )?/i, '')}`);

        const loading = document.createElement('option');
        loading.textContent = 'Loading current options…';
        select.append(loading);

        const state = document.createElement('p');
        state.className = 'wwfs-pf__product-state';
        state.textContent = 'Checking current options and availability…';

        const buyRow = document.createElement('div');
        buyRow.className = 'wwfs-pf__product-buy-row';

        const quantity = document.createElement('div');
        quantity.className = 'wwfs-pf__quantity';

        const minus = document.createElement('button');
        minus.className = 'wwfs-pf__quantity-button';
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'Reduce quantity');

        const quantityInput = document.createElement('input');
        quantityInput.className = 'wwfs-pf__quantity-input';
        quantityInput.type = 'number';
        quantityInput.min = '1';
        quantityInput.max = '99';
        quantityInput.value = '1';
        quantityInput.inputMode = 'numeric';
        quantityInput.setAttribute('aria-label', `Quantity for ${destination.label.replace(/^View (the )?/i, '')}`);

        const plus = document.createElement('button');
        plus.className = 'wwfs-pf__quantity-button';
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Increase quantity');
        quantity.append(minus, quantityInput, plus);

        const addButton = document.createElement('button');
        addButton.className = 'wwfs-pf__product-add';
        addButton.type = 'button';
        addButton.disabled = true;
        addButton.textContent = 'Add to cart';
        buyRow.append(quantity, addButton);

        checkbox.addEventListener('change', () => this.updateBundleButton());
        minus.addEventListener('click', () => {
          quantityInput.value = String(Math.max(1, this.normaliseQuantity(quantityInput.value) - 1));
        });
        plus.addEventListener('click', () => {
          quantityInput.value = String(Math.min(99, this.normaliseQuantity(quantityInput.value) + 1));
        });
        quantityInput.addEventListener('change', () => {
          quantityInput.value = String(this.normaliseQuantity(quantityInput.value));
        });

        const control = {
          checkbox,
          select,
          state,
          destination,
          safeUrl,
          media,
          vendor,
          productLink,
          price,
          variantLabel,
          variantButtons,
          quantityInput,
          addButton,
          variants: []
        };
        select.addEventListener('change', () => this.selectProductVariant(control, select.value));
        addButton.addEventListener('click', () => this.addSingleProduct(control));

        picker.append(variantLabel, variantButtons, select, state, buyRow, checkLabel);
        content.append(picker);

        return control;
      }

      async hydrateProductControl(control) {
        try {
          const productUrl = new URL(control.safeUrl, window.location.origin);
          const response = await fetch(`${productUrl.pathname.replace(/\/$/, '')}.js`, {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Product options could not be loaded');

          const product = await response.json();
          const variants = Array.isArray(product.variants)
            ? product.variants.filter((variant) => variant.available)
            : [];

          control.vendor.textContent = product.vendor || 'WWFS';
          control.productLink.textContent = product.title || control.destination.label.replace(/^View (the )?/i, '');
          control.productLink.setAttribute('aria-label', `View ${control.productLink.textContent}`);

          const imageUrl = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'wwfs-pf__product-image';
            image.src = imageUrl;
            image.alt = product.title || '';
            image.loading = 'lazy';
            image.decoding = 'async';
            control.media.replaceChildren(image);
          } else {
            control.media.textContent = 'View product';
          }

          control.select.replaceChildren();
          control.variantButtons.replaceChildren();
          control.variants = variants;

          if (!variants.length) {
            const unavailable = document.createElement('option');
            unavailable.textContent = 'No options currently available';
            control.select.append(unavailable);
            control.state.textContent = 'Open the product page to check availability or ask WWFS.';
            control.price.textContent = 'Currently unavailable';
            return;
          }

          variants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            const variantName = variant.title && variant.title !== 'Default Title'
              ? variant.title
              : 'Standard option';
            option.textContent = `${variantName}: ${this.formatMoney(variant.price)}`;
            control.select.append(option);
          });

          if (variants.length > 1 && variants.length <= 12) {
            variants.forEach((variant, index) => {
              const button = document.createElement('button');
              button.className = 'wwfs-pf__variant-button';
              button.type = 'button';
              button.dataset.variantId = String(variant.id);
              button.textContent = variant.title && variant.title !== 'Default Title'
                ? variant.title
                : 'Standard';
              button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
              button.addEventListener('click', () => this.selectProductVariant(control, String(variant.id)));
              control.variantButtons.append(button);
            });
            control.variantButtons.hidden = false;
            control.select.hidden = true;
          } else {
            control.variantButtons.hidden = true;
            control.select.hidden = variants.length === 1;
          }

          control.checkbox.disabled = false;
          control.select.disabled = false;
          control.addButton.disabled = false;
          control.variantLabel.textContent = variants.length === 1 ? 'Available option' : 'Choose size, colour or finish';
          control.state.textContent = 'In stock and available to add.';
          this.selectProductVariant(control, String(variants[0].id));
          this.updateBundleButton();
        } catch (error) {
          control.select.replaceChildren();
          const fallback = document.createElement('option');
          fallback.textContent = 'Choose on the product page';
          control.select.append(fallback);
          control.state.textContent = 'Live options are unavailable here; open the product page to choose.';
          control.price.textContent = 'See product page';
        }
      }

      selectProductVariant(control, variantId) {
        const variant = control.variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;

        control.select.value = String(variant.id);
        control.price.textContent = this.formatMoney(variant.price);
        control.variantButtons.querySelectorAll('[data-variant-id]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.variantId) === String(variant.id) ? 'true' : 'false');
        });

        const variantImage = variant.featured_image && (variant.featured_image.src || variant.featured_image);
        const image = control.media.querySelector('img');
        if (image && variantImage) image.src = variantImage;
      }

      normaliseQuantity(value) {
        const quantity = Number.parseInt(value, 10);
        if (!Number.isFinite(quantity)) return 1;
        return Math.min(99, Math.max(1, quantity));
      }

      async addSingleProduct(control) {
        const id = Number(control.select.value);
        if (!Number.isInteger(id) || id <= 0) return;

        const quantity = this.normaliseQuantity(control.quantityInput.value);
        control.quantityInput.value = String(quantity);
        control.addButton.disabled = true;
        control.addButton.textContent = 'Adding…';
        control.state.textContent = 'Adding this product to your basket.';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: [{ id, quantity }] })
          });
          if (!response.ok) throw new Error('This option could not be added. Check its availability and try again.');

          control.state.textContent = `${quantity} added to your basket.`;
          control.addButton.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(() => {
            control.addButton.disabled = false;
            control.addButton.textContent = 'Add to cart';
          }, 1600);
        } catch (error) {
          control.state.textContent = error.message || 'The product could not be added.';
          control.addButton.disabled = false;
          control.addButton.textContent = 'Try again';
        }
      }

      createBundlePanel() {
        const panel = document.createElement('div');
        panel.className = 'wwfs-pf__bundle';

        const title = document.createElement('h4');
        title.className = 'wwfs-pf__bundle-title';
        title.textContent = 'Build your project bundle';

        const copy = document.createElement('p');
        copy.className = 'wwfs-pf__bundle-copy';
        copy.textContent = 'Tick every product you want from this result and choose its option where shown. Add them together without running the finder again. Alternatives are left for you to choose, so nothing is added automatically.';

        const actions = document.createElement('div');
        actions.className = 'wwfs-pf__bundle-actions';

        const button = document.createElement('button');
        button.className = 'wwfs-pf__bundle-button';
        button.type = 'button';
        button.disabled = true;
        button.textContent = 'Add selected products to basket';
        button.addEventListener('click', () => this.addSelectedProducts());

        const cart = document.createElement('a');
        cart.className = 'wwfs-pf__bundle-cart';
        cart.href = '/cart';
        cart.textContent = 'View basket';

        const status = document.createElement('p');
        status.className = 'wwfs-pf__bundle-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');

        actions.append(button, cart);
        panel.append(title, copy, actions, status);
        this.bundleButton = button;
        this.bundleStatus = status;
        return panel;
      }

      updateBundleButton() {
        if (!this.bundleButton || !Array.isArray(this.bundleControls)) return;
        const count = this.bundleControls.filter((control) => control.checkbox.checked && !control.checkbox.disabled).length;
        this.bundleButton.disabled = count === 0;
        this.bundleButton.textContent = count
          ? `Add ${count} selected product${count === 1 ? '' : 's'} to basket`
          : 'Add selected products to basket';
      }

      async addSelectedProducts() {
        const selected = this.bundleControls.filter(
          (control) => control.checkbox.checked && !control.checkbox.disabled && control.select.value
        );
        if (!selected.length) return;

        const quantities = new Map();
        selected.forEach((control) => {
          const id = Number(control.select.value);
          const quantity = this.normaliseQuantity(control.quantityInput.value);
          control.quantityInput.value = String(quantity);
          if (Number.isInteger(id) && id > 0) quantities.set(id, (quantities.get(id) || 0) + quantity);
        });
        const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
        if (!items.length) return;

        this.bundleButton.disabled = true;
        this.bundleButton.textContent = 'Adding products…';
        this.bundleStatus.textContent = 'Adding the selected products to your basket.';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            let message = 'One or more products could not be added. Review the selected options and try again.';
            try {
              const error = await response.json();
              if (typeof error.description === 'string') message = error.description;
            } catch (parseError) {
              // Keep the safe fallback message.
            }
            throw new Error(message);
          }

          this.bundleStatus.textContent = 'Products added. Opening your basket…';
          window.location.assign('/cart');
        } catch (error) {
          this.bundleStatus.textContent = error.message || 'The products could not be added. Please try again or open each product page.';
          this.updateBundleButton();
        }
      }

      formatMoney(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '';
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        }).format(amount / 100);
      }

      createNotice(noticeData) {
        const notice = document.createElement('div');
        notice.className = `wwfs-pf__notice wwfs-pf__notice--${noticeData.tone || 'warning'}`;
        notice.setAttribute('role', 'note');

        const title = document.createElement('p');
        title.className = 'wwfs-pf__notice-title';
        title.textContent = noticeData.title;

        const text = document.createElement('p');
        text.className = 'wwfs-pf__notice-text';
        text.textContent = noticeData.text;

        notice.append(title, text);
        return notice;
      }

      safeUrl(path) {
        if (typeof path !== 'string' || !/^\/(?!\/)/.test(path)) return null;

        try {
          const parsed = new URL(path, window.location.origin);
          if (parsed.origin !== window.location.origin) return null;
          return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        } catch (error) {
          return null;
        }
      }

      announce(message) {
        this.status.textContent = '';
        window.requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }

      validateGraph(graph) {
        if (!graph || !graph.start || !Array.isArray(graph.start.options)) throw new Error('Invalid start node');
        if (!graph.nodes || !graph.results || !graph.destinations) throw new Error('Incomplete graph');

        const visiting = new Set();
        const visited = new Set();

        const validateOptions = (options) => {
          if (!Array.isArray(options) || options.length === 0) throw new Error('Empty options');

          options.forEach((option) => {
            const hasNext = typeof option.next === 'string';
            const hasResult = typeof option.result === 'string';
            if (hasNext === hasResult) throw new Error('Each option needs one destination');
            if (!option.value || !option.label) throw new Error('Incomplete option');
            if (hasNext && !graph.nodes[option.next]) throw new Error('Missing node');
            if (hasResult && !graph.results[option.result]) throw new Error('Missing result');
          });
        };

        const visit = (nodeId) => {
          if (visited.has(nodeId)) return;
          if (visiting.has(nodeId)) throw new Error('Decision cycle');
          visiting.add(nodeId);
          const node = graph.nodes[nodeId];
          validateOptions(node.options);
          node.options.forEach((option) => {
            if (option.next) visit(option.next);
          });
          visiting.delete(nodeId);
          visited.add(nodeId);
        };

        validateOptions(graph.start.options);
        graph.start.options.forEach((option) => {
          if (option.next) visit(option.next);
        });

        Object.values(graph.results).forEach((result) => {
          if (!result.title || !result.summary || !Array.isArray(result.links) || result.links.length === 0) {
            throw new Error('Invalid result');
          }

          result.links.forEach((link) => {
            const destination = graph.destinations[link.destination];
            if (!destination || !this.safeUrl(destination.url)) throw new Error('Invalid destination');
          });
        });
      }
    }

    customElements.define('wwfs-project-builder-v5', WWFSProjectFinder);
  }

  } catch(e) { console.error(e); }
})();
})();
